import { render, staticRenderFns } from "./DialogArchiveWorkspace.vue?vue&type=template&id=9cf42508"
import script from "./DialogArchiveWorkspace.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogArchiveWorkspace.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DialogArchiveWorkspace.vue?vue&type=style&index=0&id=9cf42508&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports